<script setup lang="ts">
import { computed, useSlots } from 'vue'

interface IProps {
  value?: string
  offUpperCase?: boolean
}

const props = defineProps<IProps>()
const slots = useSlots()

const parsedValue = computed(() => {
  if (props.offUpperCase) return props.value
  return props.value?.toUpperCase()
})
</script>

<template>
  <span class="chip-container">
    <slot v-if="slots.default" />
    <template v-else>
      {{ parsedValue }}
    </template>
  </span>
</template>

<style scoped lang="scss">
.chip-container {
  @apply text-primary/40 bg-primary/5 block w-fit;
  border-radius: 4px;
  padding: 4px;
  line-height: 1;
  font-size: 12px;
  cursor: default;
}
</style>